import { render, staticRenderFns } from "./EventPostList.vue?vue&type=template&id=9c9c98f0"
import script from "./EventPostList.vue?vue&type=script&lang=ts"
export * from "./EventPostList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports